// =============================================================================
// timetable-filter.ts – Filtering trips by departure window
// =============================================================================

import type { Trip } from "./types.js";
import { getReferenceTime } from "./timetable-data.js";

export type FilterWindow = 15 | 30 | 60 | "all";

/**
 * Filters the trips to include only those departing between currentMin and currentMin + windowMin.
 * If windowMin is "all", returns all trips.
 */
export function filterByWindow(
  trips: Trip[],
  currentMin: number,
  windowMin: FilterWindow,
  referenceStops: string[]
): Trip[] {
  if (windowMin === "all") {
    return trips;
  }

  const limitMin = currentMin + windowMin;
  return trips.filter((trip) => {
    const refMin =
      trip._refMin !== undefined ? trip._refMin : getReferenceTime(trip, referenceStops);
    if (refMin === null || refMin === undefined) return false;
    return refMin >= currentMin && refMin <= limitMin;
  });
}

/**
 * Returns a user-friendly label for the filter window.
 */
export function getFilterLabel(window: FilterWindow): string {
  if (window === "all") return "Tutto";
  if (window === 60) return "1 ora";
  return `${window} min`;
}
